<template>
  <section class="bg-gradient-to-br from-blue-100 via-white to-purple-100 min-h-screen flex items-center justify-center">
    <div class="w-full max-w-2xl mx-auto bg-white rounded-lg shadow-md p-6 flex flex-col h-[70vh]">
      <!-- Header -->
      <div class="flex items-center gap-3 mb-6 border-b pb-4">
        <div class="bg-blue-600 rounded-full p-2">
          <svg class="h-7 w-7 text-white" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 20h9" />
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m0 0H3" />
          </svg>
        </div>
        <h2 class="text-2xl font-bold text-gray-800">Chat with Diligint Agent</h2>
      </div>
      <!-- Chat messages -->
      <div class="flex-1 overflow-y-auto space-y-4 mb-4">
        <div v-for="(msg, idx) in chat" :key="idx" class="flex"
          :class="msg.role === 'user' ? 'justify-end' : 'justify-start'">
          <div
            :class="[
              'px-4 py-2 rounded-lg max-w-[80%] shadow',
              msg.role === 'user'
                ? 'bg-blue-100 text-blue-900 rounded-br-none'
                : 'bg-gray-100 text-gray-700 rounded-bl-none'
            ]"
          >
            {{ msg.text }}
          </div>
        </div>
        <div v-if="chat.length === 0" class="bg-gray-50 rounded-lg p-4 text-gray-600 text-center">
          <span>How can I help you today? Type your question below to chat with the agent.</span>
        </div>
      </div>
      <!-- Input -->
      <form @submit.prevent="sendMessage" class="flex items-center gap-2 border-t pt-4">
        <input
          v-model="message"
          type="text"
          placeholder="Type your message..."
          class="flex-1 px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
        <button
          type="submit"
          class="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-semibold transition"
        >
          Send
        </button>
      </form>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue'

const message = ref('')
const chat = ref([])

function sendMessage() {
  if (!message.value.trim()) return
  chat.value.push({ role: 'user', text: message.value })
  setTimeout(() => {
    chat.value.push({
      role: 'agent',
      text: "I'm your Diligint agent. How can I assist you?",
    })
  }, 700)
  message.value = ''
}
</script>